import shop from "../api/shop";
import {
  CART_STORE,
  ADD_TO_CART,
  UPDATE_TO_CART,
  DELETE_CART_PRODUCT,
  DELETE_CART,
  SELECT_ALL_CART_PRODUCT,
  SELECT_CART_PRODUCT,
  DESELECT_ALL_CART_PRODUCT,
  DESELECT_CART_PRODUCT,
  DELETE_SELECTED_CART_PRODUCT,
  CART_SET_NOTE,
  FINALIZE_ORDER,
  CHANGE_PRODUCT_QUANTITY,
  DELETE_ALL_PRODUCTS_QUANTITY,
  CART_AVAILABLE_TO_IMPORT,
  CLEAR_CUSOMER_DATA,
  SET_CART_NOTE,
  CART_IS_IMPORTING,
  TEMPORAL_IMPORTED_DATA,
  IMPORT_CSV_DATA,
  LOADING_CART,
  LOADING_IMPORT,
  RESET_STATE,
  SET_OPENED_ORDER,
  DISABLE_OPENED_ORDER,
  CLEAR_CART_NOTE,
  CLEAR_DUAL_CART,
  FILL_DUAL_CART,
  SET_DUAL_CART_DATA
} from "./actionTypes";
import { cartState } from "./stateModel";
import { toggleModal } from "./common";

// ------------------------------------
// Actions
// ------------------------------------

export const clearNote = () => ({
  type: CLEAR_CART_NOTE
});

const receiveCart = cart => ({
  type: CART_STORE,
  cart
});

const changeProductQuantityUnsafe = product => ({
  type: CHANGE_PRODUCT_QUANTITY,
  product
});

const deleteAllProductsQuantityUnsafe = () => ({
  type: DELETE_ALL_PRODUCTS_QUANTITY
});

export const storeCart = cart => dispatch => {
  dispatch(receiveCart(cart));
  dispatch(loadingCartItems(false));
  cart.map(c => {
    dispatch(changeProductQuantityUnsafe(c));
  });
};
const addToCartUnsafe = product => ({
  type: ADD_TO_CART,
  product
});

const updateProductCartUnsafe = product => ({
  type: UPDATE_TO_CART,
  product
});

export const addToCart = (productId, quantity) => (dispatch, getState) => {
  // create cart product object
  const wholeProducts = getState().product.fullList;
  const products = getState().product.list;
  const productsInCart = getState().product.inCart;
  const cartList = getState().cart.list;

  let product = Object.assign({}, wholeProducts.find(p => p.id === productId));
  if (productsInCart.findIndex(p => p.id === productId) !== -1) {
    const productInCart = productsInCart.find(p => p.id === productId);
    product.quantity = productInCart.quantity;
  }

  const cartListProduct = Object.assign(
    {},
    cartList.find(p => p.id === productId)
  );

  product.quantity = !isNaN(parseInt(quantity))
    ? cartListProduct && cartListProduct.quantity === product.quantity
      ? parseInt(quantity) + 1
      : parseInt(quantity)
    : 1;
  product.editation = false;
  product.price = product.sale ? product.priceSale : product.price;
  // check if need to add or update object
  if (getState().cart.list.findIndex(cp => cp.id === productId) === -1) {
    dispatch(addToCartUnsafe(product));
    dispatch(setOpenedOrder(getState().customer.actionOnCustomer, true));
  } else {
    dispatch(updateProductCartUnsafe(product));
  }
  dispatch(changeProductQuantityUnsafe(product));
};

const deleteCartProductUnsafe = productId => ({
  type: DELETE_CART_PRODUCT,
  productId
});

export const deleteCartProductByOrderType = (productId, orderType) => (
  dispatch,
  getState
) => {
  dispatch(deleteCartProductUnsafe(productId));
  dispatch(changeProductQuantityUnsafe({ id: productId, quantity: null }));
  if (getState().cart.list.length === 0) {
    dispatch(setOpenedOrder(orderType, false));
  }
  shop.removeCartItem(
    productId,
    getState().common.user.personal.id,
    orderType,
    p => {
      p.then(data => console.log("item deleted " + data));
    },
    0
  );
};

export const deleteCartProduct = productId => (dispatch, getState) => {
  dispatch(deleteCartProductUnsafe(productId));
  dispatch(changeProductQuantityUnsafe({ id: productId, quantity: null }));
  if (getState().cart.list.length === 0) {
    dispatch(setOpenedOrder(getState().customer.actionOnCustomer, false));
  }
  shop.removeCartItem(
    productId,
    getState().common.user.personal.id,
    getState().customer.actionOnCustomer,
    p => {
      p.then(data => console.log("item deleted " + data));
    },
    0
  );
};

const deleteCartUnsafe = () => ({
  type: DELETE_CART
});

export const setOpenedOrder = (orderType, status) => ({
  type: SET_OPENED_ORDER,
  orderType,
  status
});

export const deleteCart = () => (dispatch, getState) => {
  dispatch(deleteCartUnsafe());
  dispatch(deleteAllProductsQuantityUnsafe());
  dispatch(setOpenedOrder(getState().customer.actionOnCustomer, false));
  shop.removeCart(
    getState().common.user.personal.id,
    getState().customer.actionOnCustomer,
    p => {
      p.then(data => console.log("cart deleted " + data));
    },
    0
  );
};

export const changeCartQuantity = cartProduct => dispatch => {
  dispatch(updateProductCartUnsafe(cartProduct));
  dispatch(changeProductQuantityUnsafe(cartProduct));
};

const deleteSelectedCartProductsUnsafe = () => ({
  type: DELETE_SELECTED_CART_PRODUCT
});

export const deleteSelectedCartProducts = () => dispatch => {
  dispatch(deleteSelectedCartProductsUnsafe());
};

const selectCartProductUnsafe = cartProductId => ({
  type: SELECT_CART_PRODUCT,
  cartProductId
});

const deselectCartProductUnsafe = cartProductId => ({
  type: DESELECT_CART_PRODUCT,
  cartProductId
});

export const selectCartProduct = cartProductId => (dispatch, getState) => {
  if (
    getState().cart.toDelete &&
    getState().cart.toDelete.findIndex(ptd => ptd === cartProductId) !== -1
  ) {
    dispatch(deselectCartProductUnsafe(cartProductId));
  } else {
    dispatch(selectCartProductUnsafe(cartProductId));
  }
};

const selectAllCartProductsUnsafe = cartProductsId => ({
  type: SELECT_ALL_CART_PRODUCT,
  cartProductsId
});

const deselectAllCartProductsUnsafe = () => ({
  type: DESELECT_ALL_CART_PRODUCT
});

export const selectAllCartProducts = () => (dispatch, getState, shop) => {
  let cartList = getState().cart.list.map(product => product.id);
  if (cartList.length === getState().cart.toDelete.length) {
    dispatch(deselectAllCartProductsUnsafe(cartList));
  } else {
    dispatch(selectAllCartProductsUnsafe(cartList));
  }
};

const setCartNoteUnsafe = note => ({
  type: CART_SET_NOTE,
  note
});

export const setCartNote = note => dispatch => {
  dispatch(setCartNoteUnsafe(note));
};

const finalizeOrderUnsafe = () => ({
  type: FINALIZE_ORDER
});

export const finalizeOrder = (openedOrders = false) => (dispatch, getState) => {
  dispatch(finalizeOrderUnsafe());
  openedOrders &&
    dispatch(disableOpenedOrder(getState().common.user.personal.id));
};

const disableOpenedOrder = customerId => ({
  type: DISABLE_OPENED_ORDER,
  customerId: customerId
});

const setCartIsImporting = state => ({
  type: CART_IS_IMPORTING,
  state
});

const setAvailableCart = state => ({
  type: CART_AVAILABLE_TO_IMPORT,
  state
});

const loadingCartItems = status => ({
  type: LOADING_CART,
  status
});

export const importCart = () => (dispatch, getState) => {
  dispatch(loadingCartItems(true));
  const { id } = getState().common.user.personal;
  dispatch(setCartIsImporting(true));
  shop.importCartItems(
    id,
    getState().customer.actionOnCustomer,
    cartFromApi => {
      cartFromApi.then(cartItems => {
        dispatch(storeCart(cartItems));
        dispatch(setAvailableCart(false));
        dispatch(setCartIsImporting(false));
        dispatch(loadingCartItems(false));
      });
    }
  );
};

export const setNote = note => dispatch => dispatch(setNoteUnsafe(note));

export const setNoteToDB = note => (dispatch, getState) => {
  const x = getState();
  shop.setCartNote(
    note,
    getState().common.user.personal.id,
    getState().customer.actionOnCustomer,
    cartNote => {
      cartNote.then(data => console.log("cart note set " + data));
    }
  );
};

const setNoteUnsafe = note => ({
  type: SET_CART_NOTE,
  note
});

export const importCSVdataUnsafe = data => ({
  type: IMPORT_CSV_DATA,
  data
});

const loadingImport = status => ({
  type: LOADING_IMPORT,
  status
});

export const importCSVdata = () => (dispatch, getState) => {
  console.log("importing");
  const { temporalImportedData } = getState().cart;
  dispatch(loadingImport(true));
  shop.getImportedItems(
    temporalImportedData,
    getState().common.user.personal.id,
    getState().customer.actionOnCustomer,
    itemsPromise => {
      itemsPromise.then(items => {
        dispatch(loadingImport(false));
        console.log("item deleted " + items);
        dispatch(importCSVdataUnsafe(items));
        dispatch(toggleModal("import_csv_modal", false));
      });
    },
    0
  );
};

export const changeApprovementCSV = index => (dispatch, getState) => {
  const csvData = getState().cart.temporalImportedData || [];
  csvData[index].approved = false;
  dispatch(temporalImportedData(csvData));
};

export const temporalImportedData = data => ({
  type: TEMPORAL_IMPORTED_DATA,
  data
});

export const confirmCartItems = (productId, customer, ozPrice, orderType) => (
  dispatch,
  getState
) => {
  const cartItem = getState().cart.list.find(p => p.id === productId);
  const quantity = cartItem ? cartItem.quantity : 1;
  if (quantity) {
    shop.addCartItem(
      {
        product: productId,
        quantity: parseInt(quantity, 10),
        customer_id: customer,
        order_type: orderType,
        ozPrice: parseFloat(ozPrice)
      },
      cartItemFromApi => {
        cartItemFromApi.then(cartItem => {
          console.log("item changed:");
          console.log(cartItem);
        });
      },
      0
    );
  }
};

export const getInCartProducts = state => (!state ? [] : state);
export const getCartProductQuantity = (state, productId) => {
  if (!productId) return undefined;
  // let cartProduct = state && state.list ? state.list.find(p => p.id === productId) : undefined;
  let cartProduct;
  if (state && state.list && state.list[0]) {
    cartProduct = state.list.find(p => p.id === productId);
  }
  return cartProduct ? cartProduct.quantity : undefined;
};
export const getCartProducts = state => {
  return !state ? [] : state;
};
export const getTotal = (cartList, shippingCost) =>
  cartList && cartList.length > 0
    ? (
      cartList.reduce(
        (total, item) => total + item.price * item.quantity,
        0
      ) + (shippingCost ? parseFloat(shippingCost) : 0)
    ).toFixed(2)
    : 0;
export const getItemsCount = state => state && state.length > 0 && state.length;
export const getCartProductsToDelete = state => state || [];
export const getCartNote = state => state || null;

const clearDualCartItemsUnsafe = () => ({
  type: CLEAR_DUAL_CART
});

export const clearDualCartItems = () => dispatch => {
  dispatch(clearDualCartItemsUnsafe());
};

const fillDualCartItemsUnsafe = (list) => ({
  type: FILL_DUAL_CART, list
});

export const fillDualCartItems = list => dispatch => {
  dispatch(fillDualCartItemsUnsafe(list));
};

const setDualCartDataUnsafe = (data) => ({
  type: SET_DUAL_CART_DATA, data
});

export const setDualCartData = data => dispatch => {
  dispatch(setDualCartDataUnsafe(data));
};


export const importDualCartProduct = (customerId, list) => (dispatch, getState) => {
  dispatch(setCartIsImporting(true))
  shop.importSpecialCart(
    customerId,
    list,
    p => {
      p.then(data => {
        console.log("item deleted " + data);
        dispatch(fillDualCartItemsUnsafe(data));
        dispatch(setDualCartData({ isUploaded: true }))
        dispatch(setCartIsImporting(false))
      })
    },
    0
  );
};


// ------------------------------------
// Reducer
// ------------------------------------

export default function cartReducer(state = cartState, action) {
  // debugger;
  switch (action.type) {
    case CART_STORE:
      return {
        ...state,
        list: Array.isArray(action.cart) ? action.cart : []
      };
    case ADD_TO_CART:
      const cartProduct = {
        id: action.product.id,
        title: action.product.title,
        code: action.product.code,
        ean: action.product.ean,
        price: action.product.ozPrice
          ? Number(action.product.ozPrice)
          : action.product.price,
        slug: action.product.slug,
        quantity: action.product.quantity,
        discount: action.product.discount,
        image: action.product.image,
        specialMinPrice: action.product.specialMinPrice,
        minPrice: action.product.minPrice
      };

      if (action.product.sale) {
        cartProduct.price = action.product.priceSale;
      }

      const cartItemList = Object.assign([], state.list);
      cartItemList.push(cartProduct);

      return {
        ...state,
        list: sortCartItemsBySKU(cartItemList)
      };
    case UPDATE_TO_CART:
      const cartList = Object.assign([], state.list);
      let cartProductToUpdateIndex = cartList.findIndex(
        cp => cp.id === action.product.id
      );
      const cartProductToUpdate = {
        id: action.product.id,
        title: action.product.title,
        code: action.product.code,
        ean: action.product.ean,
        price: action.product.ozPrice
          ? Number(action.product.ozPrice)
          : action.product.price,
        slug: action.product.slug,
        quantity: action.product.quantity,
        discount: action.product.discount,
        image: action.product.image,
        specialMinPrice: action.product.specialMinPrice,
        minPrice: action.product.minPrice
      };
      cartList[cartProductToUpdateIndex] = cartProductToUpdate;
      return {
        ...state,
        list: cartList
      };
    case DELETE_CART_PRODUCT:
      const cartProductToDeleteIndex = state.list.findIndex(
        cp => cp.id === action.productId
      );
      let clone = Object.assign([], state.list);
      clone.splice(cartProductToDeleteIndex, 1);
      return {
        ...state,
        list: clone
      };
    case DELETE_CART:
      return {
        ...state,
        list: [],
        toDelete: []
      };
    case SELECT_CART_PRODUCT:
      if (state.toDelete) {
        return {
          ...state,
          toDelete: [...state.toDelete, action.cartProductId]
        };
      } else {
        return {
          ...state,
          toDelete: [action.cartProductId]
        };
      }
    case DESELECT_CART_PRODUCT:
      const cartProductToSetToDeleteIndex = state.toDelete.findIndex(
        ptd => ptd === action.productId
      );
      let cloneToDelete = Object.assign([], state.toDelete);
      cloneToDelete.splice(cartProductToSetToDeleteIndex, 1);
      return {
        ...state,
        toDelete: cloneToDelete
      };
    case SELECT_ALL_CART_PRODUCT:
      return {
        ...state,
        toDelete: action.cartProductsId
      };
    case DESELECT_ALL_CART_PRODUCT:
      return {
        ...state,
        toDelete: []
      };
    case DELETE_SELECTED_CART_PRODUCT:
      let cloneCartList = Object.assign([], state.list);
      let newCartList = [];
      cloneCartList.map(pl => {
        if (state.toDelete.findIndex(ptd => ptd === pl.id) === -1) {
          newCartList.push(state.list.find(cp => cp.id === pl.id));
        }
      });
      return {
        ...state,
        list: newCartList,
        toDelete: []
      };
    case CART_SET_NOTE:
      return {
        ...state,
        note: action.note
      };
    case FINALIZE_ORDER:
      return cartState;
    case CART_AVAILABLE_TO_IMPORT:
      return {
        ...state,
        availableToImport: action.state
      };
    case SET_CART_NOTE:
      return { ...state, note: action.note ? action.note : "" };
    case CART_IS_IMPORTING:
      return { ...state, isImporting: action.state };
    case CLEAR_CUSOMER_DATA:
      return cartState;
    case TEMPORAL_IMPORTED_DATA:
      return { ...state, temporalImportedData: action.data };
    case IMPORT_CSV_DATA:
      return importData(state, action.data);
    case LOADING_CART:
      return { ...state, loadingItems: action.status };
    case LOADING_IMPORT:
      return { ...state, loadingImport: action.status };
    case RESET_STATE:
      return cartState;
    case CLEAR_CART_NOTE:
      return { ...state, note: null };
    case CLEAR_DUAL_CART: {
      return { ...state, dualData: cartState.dualData }
    }
    case FILL_DUAL_CART: {
      return { ...state, dualData: { ...state.dualData, list: action.list } }
    }
    case SET_DUAL_CART_DATA: {
      return { ...state, dualData: { ...state.dualData, ...action.data } }
    }
    default:
      return state;
  }
}

export const sortCartItemsBySKU = cartItems => {
  if (cartItems.every(i => i.code)) {
    return cartItems.sort((a, b) =>
      a.code
        .toString()
        .toLowerCase()
        .localeCompare(b.code.toString().toLowerCase())
    )
  }
  return cartItems;
};

const importData = (state, data) => {
  let dataArr = state.list || [];
  data.map(row => {
    if (row.approved) {
      delete row.approved;
      dataArr.push(row);
    }
  });
  return { ...state, list: sortCartItemsBySKU(dataArr) };
};



// WEBPACK FOOTER //
// ./src/store/cart.js